import {
  formatLeagueLabel,
  resolveLeagueIcon,
} from "@/constants/leagueInfo"
import { AcademicLeague } from "@/types/battle"

export default function LeagueLabel({
  league,
  iconSize = 22,
  fallback = "—",
}: {
  league: AcademicLeague | null | undefined
  iconSize?: number
  fallback?: string
}) {
  const icon = resolveLeagueIcon(league)
  const label = formatLeagueLabel(league) || fallback
  return (
    <span className="inline-flex items-center gap-1">
      {icon ? (
        <img src={icon} alt="" width={iconSize} height={iconSize} className="object-contain" />
      ) : null}
      <span>{label}</span>
    </span>
  )
}
